import { type FC } from 'react'
import { useIntl } from 'react-intl'

export const ContactPageMetas: FC = () => {
  const intl = useIntl()

  const title = intl.formatMessage({ id: 'header.link.label.contactAndHelp' })
  const description = intl.formatMessage({
    id: 'header.link.label.contactAndHelp',
  })

  return (
    <>
      <title>{title}</title>
      <meta content={title} property="og:title" />
      <meta content={title} property="twitter:title" />
      <meta content={description} name="description" />
      <meta content={description} property="og:description" />
      <meta content={description} property="twitter:description" />
    </>
  )
}
